import { useState } from 'react';
import useDebounce from '../../../hooks/useDebounce';
import bem from '../../../utils/bem';
import Autocomplete from '../../Atoms/FormComponents/Autocomplete';
import searchPageRedirect from '../../../utils/searchPageRedirect';
import useGlobalSearchAutocompleteValues from '../../../hooks/useGlobalSearchAutocompleteValues';

const GlobalSearchDynamic = () => {
  const [searchTerm, setSearchTerm] = useState({});

  const baseClass = 'global-search-dynamic';
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const autocompleteSettings = {
    name: 'globalSearch',
    placeholder: Drupal.t('What can we help you with today?'),
    state: searchTerm,
    clearButton: true,
  };

  const searchCallback = () => {
    searchPageRedirect(searchTerm.globalSearch);
  };

  const autocompleteResults = useGlobalSearchAutocompleteValues({
    searchTerm,
    debouncedSearchTerm,
  });

  return (
    <div className={bem(baseClass, [], '')}>
      <Autocomplete
        settings={autocompleteSettings}
        setState={setSearchTerm}
        searchCallback={searchCallback}
        searchIcon="search-thick"
      >
        {autocompleteResults}
      </Autocomplete>
    </div>
  );
};

export default GlobalSearchDynamic;
